
const en = {
    logo: 'ZOSHANG',
    // 导航
    menu: {
        home: 'Home',
        constructionMana: 'construction',
        addConstruction: 'addConstruction',
        meterBinding: 'meterBinding',

        householdMana: 'household',
        householdList: 'householdList',
        addHousehold: 'addHousehold',

        equipmentMana: 'equipment',
        gatewayMana: 'gateway',
		directlyMana:'directly',
        plateMana: 'plate',

        systemSetting: 'systemSetting',
        priceSetting: 'priceSetting',
        billSetting: 'billSetting',

        setteleMana: 'settele',
        dosage: 'dosage',
        receivable: 'receivable',
        userPay: 'userPay',
        residentBill: 'residentBill',
        residentDosage: 'residentDosage',
        userEquipment: 'userEquipment',
        userDetail: 'userDetail',
        defindBill: 'defindBill',

        changePassword: 'changePassword',
		headchangePassword: 'changePassword'
    },
    // 头部
    header: {
        userCenter: 'userCenter',
		userEmail:'userEmail',
        logout: 'logout',
    },
    project: {
        unInputProject: 'Please enter a project name',
		unInputProjectSystem:"Please enter a project system name",
        unInputProperty: 'Please enter property name',
        unInputProjectType: 'Select the project type',
        unInputRegions: 'Please select your region',
        addProject: 'new project',
		addProjectSystem: 'new projectsystem',
		systemName:'system name',
        proName: 'project name',
        propertyName: 'description of property',
        remark: 'remark',
        createSuccess: 'create successful',
        createProject: 'create project',
		createProjectsystem: 'create project system',
        projectType: 'project type',
        regions: 'regions',
        operation: 'operation',
    },
    // 表计统计页面
    meter: {
        bindMeter: '绑定表计',
        residenceNum: '住宅编号',
        meterType: '表计类型',
        meterNum: '表计表号',
        meterModel: '表计型号',
        gatewayNum: '网关编号',
        fancoilModel: '风盘型号',
        bindAddress: '安装位置',
        compoundTable: '复合表',
        autoMeterNum: '自定义表号',
        metrology: '计量式',
        meterInfo: '表计信息',
    },
    login: {
        title: '账号登录',
        loginbBtn: '登录',
        username: '用户名/手机号码',
        password: '密码',
        unInputUserError: '请输入用户名',
        unInputPwdError: '请输入密码',
        userLoginError: '用户名或密码错误',
        loginFailing: '登录失败',
        invaildUser: '用户名不存在',
        phoneBind: '绑定手机号码',
        telephone: '手机号码',
        unInputPhone: '请输入手机号码',
        errorPhone: '无效的手机号码',
        unInputCode: '请输入验证码',
        getCode: '获取验证码',
        codeError: '验证码错误'
    },
    residence: {
        'name': '名称',
        'remark': '备注',
        'ide': '编号',
        'roomArea': '房屋面积'
    },
    household: {
        baseInfo: '基本信息',
        payInfo: '支付信息',
        deviceInfo: '表计信息',
        resiNum: '住宅编号',
        holdNum: '业主编号',
        holdStatus: '业主状态',
        holdName: '业主名称',
        unitPriceType: '单价类型',
        expenseType: '计费类型',
        discount: '折扣率',
        sex: '性别',
        telephone: '手机号码',
        remain: '业主余额',
        payType: '支付类型',
        depositBank: '开户银行',
        depositNum: '开户卡号',
        deviceStatus: '设备状态',
        payNum: '支付账号',
        IDCard: '证件类型',
        IDNum: '证件号码',
        email: '电子邮箱',
        selectRes: '住宅选择',
        holdTotal: '业主总数',
        holdNormal: '正常业主',
        holdCancel: '已销户',
        resAddress: '住宅地址',
        empty: '清空',
        addHold: '添加业主',
        emptyHoldName: '请输入业主名称',
        emptyIDCard: '请选择证件类型',
        emptyIDNum: '请输入证件号码',
        emptyTele: '请输入手机号码',
        emptyPayType: '请选择支付类型',
        emptyDepBank: '请输入开户银行',
        emptyPayNum: '请输入支付账号',
        emptyUPType: '请选择单价类型',
        emptyDiscount: '请选择折扣率',
        emptyDevStatus: '请选择设备状态',
        emptyResidence: '请选择住宅',
        errorEmail: '无效的邮箱',
        errorResidence: '请选择至最后级别'
    },
    btns: {
		map:'地图',
		list:'列表',
        sure: '确定',
        search: '查询',
        save: '保存',
        edit: '编辑',
        delete: '删除',
        add: '添加',
        exports: '导出',
        cancel: '取消',
        batchAdd: '批量添加',
        singleAdd: '单个添加',
        see: '查看',
        keyword: '关键字',
        verify: '修改',
        operate: '操作',
        sureAdd: '确定并添加',
        sureSave: '确定并保存',
        cancelHold: '销户'
    },
    time: {
        second: '秒'
    },
    message: {
        tips: '提示',
        reLogin: '重新登录',
        reLoginTip: '该账号在其他地方登录，须重新登录',
        number: '数量',
        isDelLeaf: '是否确认删除{msg}?',
        deleSuccess: '删除成功',
        verifySuccess: '修改成功',
        createSuccess: '创建成功',
        unInputName: '请输入名称',
        pSelect: '请选择',
        goAdd: '继续添加',
        backHoldList: '返回业主列表',
        addHoldSuccess: '业主添加成功',
        verifyHoldSuccess: '业主修改成功'
    },
    globalCode: {
        20001000: 'Success',

        30001001: 'Bad Request Content',
        30001002: 'Invalid Parameters',
        30001003: 'Invalid Messages',

        40001001: 'Unauthorized',
        40001002: 'Device Access Forbidden',
        40001003: 'Module Access Forbidden',
        40001004: 'Project Access Forbidden',
        40001005: 'Operate Access Forbidden',
        40001006: 'Bad User Credentials',

        40011001: 'Not Found',
        40011002: 'User Existed',

        50001001: 'Internal Server Error',
        50001002: 'Database Error',
        50001003: 'Memcache Error'
    },
    lang: 'language'
}
export default en